module.exports = __webpack_public_path__ + "media/images/front/top/astellas-31e067cbfd22a1531ff8d3afe4548e5e.png";